import React, { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import CircularProgress from "@mui/material/CircularProgress";
import openSocket from "../../services/socket-io";

const SocketStatusBanner = () => {
  const [reconnecting, setReconnecting] = useState(false);

  useEffect(() => {
    const socket = openSocket();

    const onDisconnect = () => setReconnecting(true);
    const onConnect    = () => setReconnecting(false);

    socket.on("disconnect",    onDisconnect);
    socket.on("connect_error", onDisconnect);
    socket.on("connect",       onConnect);

    return () => {
      socket.off("disconnect",    onDisconnect);
      socket.off("connect_error", onDisconnect);
      socket.off("connect",       onConnect);
    };
  }, []);

  return (
    <Collapse in={reconnecting}>
      <Alert
        severity="info"
        icon={<CircularProgress size={14} color="inherit" />}
        sx={{ borderRadius: 0, py: 0.5 }}
      >
        Reconnecting to server…
      </Alert>
    </Collapse>
  );
};

export default SocketStatusBanner;
